import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Segment } from 'semantic-ui-react'

const statusContent = {
  PENDING: {
    title: 'Access Pending',
    lines: [
      'Your account has been successfully created and is awaiting approval.',
      'We are gradually expanding access to ensure a high-quality experience.',
      'You will receive a notification once access is granted.',
      'If you have questions about your access, please contact support@drivepoints.com.',
    ],
  },
  REJECTED: {
    title: 'Access Rejected',
    lines: [
      'Your account request was reviewed and access was not approved at this time.',
      'Access may be limited based on current eligibility and rollout priorities.',
      'If you believe this is an error or need additional details, please contact support@drivepoints.com.',
    ],
  },
  SUSPENDED: {
    title: 'Access Suspended',
    lines: [
      'Your account access is currently suspended.',
      'This can happen when an account requires an additional review step.',
      'If you have questions or need help resolving this, please contact support@drivepoints.com.',
    ],
  },
}

const AccountStatusMessage = ({ status, onSignOut }) => {
  const content = statusContent[status] || statusContent.PENDING

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        zIndex: 1000,
        width: '100%',
        maxWidth: '720px',
        padding: '0 1rem',
      }}
    >
      <Segment
        padded="very"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}
      >
        <h2>{content.title}</h2>
        {content.lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
        <div style={{ marginTop: '2rem' }}>
          <Button color="red" onClick={onSignOut}>
            <Icon name="sign-out" />
            Sign Out
          </Button>
        </div>
      </Segment>
    </div>
  )
}

AccountStatusMessage.propTypes = {
  status: PropTypes.string,
  onSignOut: PropTypes.func,
}

export default AccountStatusMessage
